import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingServiceRequestBackfillParams,
  IIndirectTaxFilingServiceRequestBackfillResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function backfillIndirectTaxFilingServiceRequests({
  params,
  token,
}: {
  params: IIndirectTaxFilingServiceRequestBackfillParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingServiceRequestBackfillResponse>
> {
  try {
    if (!params.filingIds?.length) {
      return { success: false, error: 'Enter at least one filing ID' };
    }

    const response = await fetcher(
      'new-sales-tax/internal/filings/service-requests',
      {
        method: 'POST',
        body: {
          corporation_id: params.corporationId,
          filing_ids: params.filingIds,
        },
      },
      token
    );

    const json = await response.json();

    if (!response.ok) {
      const message = Array.isArray(json?.message)
        ? json.message.join(', ')
        : json?.message;
      return {
        success: false,
        error:
          typeof message === 'string' && message
            ? message
            : 'Failed to backfill service requests',
      };
    }

    return {
      success: true,
      data: { results: json?.data ?? [], message: json?.message ?? '' },
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to backfill service requests',
    };
  }
}
